var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "subsidiaryInformation-form section grid-view" },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          {
            staticClass: "operations",
            staticStyle: { "margin-bottom": "5px" }
          },
          [
            _c("div", { staticClass: "triggers" }, [
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "new",
                        disabled: !_vm.isEdit,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.add()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "delete",
                        disabled: !_vm.isEdit,
                        size: "mini",
                        type: "danger"
                      },
                      on: { click: _vm.remove }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
                  )
                ],
                1
              )
            ])
          ]
        ),
        _c(
          "div",
          { staticClass: "grid-wrapper" },
          [
            _c("cargo-ag-grid", {
              key: 1,
              attrs: {
                "grid-params": _vm.girdParams,
                "grid-options": _vm.gridOptions,
                "column-defs": _vm.columnDefs,
                "row-data": _vm.finalRowData
              },
              on: {
                "update:gridParams": function($event) {
                  _vm.girdParams = $event
                },
                "update:grid-params": function($event) {
                  _vm.girdParams = $event
                }
              }
            })
          ],
          1
        )
      ]),
      _vm.queryCompanyDialog.visible
        ? _c("query-company-dialog", {
            attrs: {
              visible: _vm.queryCompanyDialog.visible,
              "is-query-parent-company": false,
              title: _vm.$t("CargoMsg.Cargo_Add")
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.queryCompanyDialog, "visible", $event)
              },
              enterEvent: _vm.addSubsidiaryCompany
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }